webpackJsonp([23],{

/***/ "isjR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-slider_5ca79641e867e2cfaccee697f9cfe13d.html";

/***/ }),

/***/ "zMz2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lazy_modules_1 = __webpack_require__("bUzP");
var VideoSlider = (function () {
    VideoSlider.$inject = ["$element", "$q"];
    function VideoSlider($element, $q) {
        this.$element = $element;
        this.$q = $q;
        this.flicktyPromise = !options.handHeld ?
            $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); }) :
            $q.reject(null);
    }
    VideoSlider.prototype.$postLink = function () {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            _this.flickity = new Flickity(_this.$element[0].firstChild, {
                cellSelector: 'video-slider .video-item',
                prevNextButtons: true,
                wrapAround: true,
                draggable: false,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
            _this.hideButtons();
        });
    };
    VideoSlider.prototype.hideButtons = function () {
        if (this.flickity.slideableWidth <= this.flickity.slider.offsetWidth + 60) {
            this.flickity.deactivatePrevNextButtons();
        }
    };
    return VideoSlider;
}());
exports.VideoSlider = VideoSlider;
angular.module('animatronApp.videoSlider', []).component('videoSlider', {
    bindings: {
        videos: '<'
    },
    controller: VideoSlider,
    templateUrl: __webpack_require__("isjR")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/23-7812b7d297ba59488b87.min.js